import React from 'react';

import styled, { css } from 'styled-components';

import Theme from 'Theme';

export const TextArea = ({
  label,
  name,
  value,
  onChange,
  inputError,
  placeholder
}) => {
  return (
    <React.Fragment>
      {label && <Label error={!!inputError}>{label}</Label>}
      <StyledArea
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(name, e.target.value)}
      />
    </React.Fragment>
  );
};

export default TextArea;

const StyledArea = styled.textarea`
  width: calc(100% - 32px);
  padding: 16px;
  padding-top: 8px;
  padding-left: 16px;
  padding-bottom: 24px;
  resize: none;

  min-height: 100px;
  border-radius: 0.25rem;

  background-color: #ebeef11c;
  border: none;
  box-shadow: 0px 0px 0px 1px #c7d7e1;
  font-family: ${Theme.primaryFont};

  font-size: 1em;
  line-height: 2em;
  font-weight: 300;

  ${(props) =>
    props.disabled &&
    `
    background-color: rgb(245, 246, 247) !important;
  `}

  ${(props) =>
    props.error &&
    `
    box-shadow: 0px 0px 0px 1px ${props.theme.dangerColor};
  `};

  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    box-shadow: 0px 0px 2px 1px ${(props) => props.theme.brandColor};
  }

  ::placeholder {
    font-weight: 300;
    color: rgb(158, 171, 180);
`;

const Label = styled.div`
  font-size: 0.9em;

  font-weight: 400;
  margin-bottom: 4px;

  color: rgb(1, 52, 83);
  transition: top 0.1s ease-out;
  font-family: ${Theme.primaryFont};

  ${({ error }) =>
    error &&
    css`
      color: ${Theme.dangerColor};
    `};
`;
